import { useTranslation } from 'react-i18next';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import { enGB, lt } from 'date-fns/locale';
import { useEffect, useState } from 'react';
import './DateTimePicker.css';

export const DateTimePicker = ({ elementId, value, onChange, dateFormat, showTime, timeFormat, timeIntervals }) => {
    const { i18n } = useTranslation();
    registerLocale('en', enGB);
    registerLocale('lt', lt);
    setDefaultLocale('en', enGB);

    const getSelectedDate = (value) => {
        return value != null && value !== '' && value !== ' '
            ? new Date(value)
            : null;
    };
    const [selectedDate, setSelectedDate] = useState(getSelectedDate(value));

    useEffect(() => {
        setSelectedDate(getSelectedDate(value));
    }, [value]);


    const handleDateChange = (date) => {
        setSelectedDate(date);
        onChange(date);
    };

    return (
        <DatePicker className={'form-control'}
                    selected={selectedDate}
                    onChange={handleDateChange}
                    dateFormat={dateFormat}
                    showTimeSelect={showTime}
                    timeFormat={timeFormat}
                    timeIntervals={timeIntervals}
                    locale={i18n.language}
                    id={elementId}
        />
    );
};